import React from "react";
import CheckboxField from "../atoms/CheckboxField";

export default ({value, selected, addFilterValue, removeFilterValue}) => <React.Fragment>
    <li className="list-group-item p-2">
        <CheckboxField
            // Every filter across every grid shares this rendering - '' represents "no value for this
            // row" (a null field, or an empty array like Courses' payment triggers), so give it one
            // consistent, readable label everywhere instead of leaving it a blank, unclickable-looking
            // checkbox.
            label={'' === value ? '(Empty)' : value}
            id={value}
            checked={selected}
            onChange={
                e => e.target.checked
                    ? addFilterValue(value)
                    : removeFilterValue(value)
            }
        />
    </li>
</React.Fragment>;
